import { Component, OnInit , Input, Output, EventEmitter} from '@angular/core';
import { FormulasService } from '../../../services/formulas.service';
import { DialogConfirmacionComponent } from '../../shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../shared/dialog-procesando/dialog-procesando.component';
import { MatDialog } from '@angular/material/dialog';
import { FormulaDTO } from '../../../models/formula-dto';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErroresService } from '../../../core/services/errores.service';

@Component({
  selector: 'app-blockly-list',
  templateUrl: './blockly-list.component.html',
  styleUrls: ['./blockly-list.component.css']
})
export class BlocklyListComponent implements OnInit {

  @Input() formulasList: any;
  @Input() permisoEdicion: boolean = true;
  @Output() VisualizarDetalle = new EventEmitter<FormulaDTO>();

  tituloTabla: string = "Formulas";
  importExport: string = "N"; //E-Solo exporta, I-Solo importa, N-No importa ni exporta
  MensajeError: string = '';
  formulaInvalida: boolean;
  eliminandoFormula: boolean;
  eliminacionInvalida: boolean;
  
  public constructor(private formulasService: FormulasService,
                    private dialog: MatDialog,
                    private snackBar: MatSnackBar,
                    private erroresService: ErroresService) {    
  }

  ngOnInit() {
  }

  add(e)
  {
    let formula: FormulaDTO = {
      Id: 0,
      Codigo: '',
      Descripcion: '',
      XMLValue: '',
      CShapValue: '',
      FormulaType: '',
      CodNomina: 0,
      StringValue: '',
      StringFormat: ''
    };
    this.visualizarDetalle(formula, 0);
  }
  
  visualizarDetalle(formula, rowIndex)
  {
    this.VisualizarDetalle.emit(formula);
  }

  delete(row, rowIndex)
  {
    let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
      width: '400px',
    });

    dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

    dialogRef.afterClosed().subscribe(result =>
    {
      if (result != null && result)
      {
        this.eliminandoFormula = true;

        let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
          width: '400px'
        });
        dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

        this.formulasService.deleteFormula(row.id).subscribe(
        response =>
        {
          let index = this.formulasList.findIndex(x => x.id == row.id);
          if (index != -1)
          {
            this.formulasList.splice(index, 1);
            this.formulasList = [...this.formulasList];
          }

          this.snackBar.open("La Fórmula se eliminó correctamente.", "OK", { duration: 10000 }); 
          this.eliminandoFormula = false;

          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });
        },
        error =>
        {
          if (error.status == 400)
          {
            this.eliminacionInvalida = true;

            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
          }
          this.eliminandoFormula = false;
          dialogProcesandoRef.close();
        });}
    }); 
  }

  

}